import script from "./Investigate.vue?vue&type=script&lang=ts&setup=true"
export * from "./Investigate.vue?vue&type=script&lang=ts&setup=true"

import "./Investigate.vue?vue&type=style&index=0&id=c1856d68&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1856d68"]])

export default __exports__